import BaseService from './base.service';

class AddressService extends BaseService {
  get basePath() {
    return 'addresses';
  }
}

export default new AddressService();
